/**
 * Gemeinsames Aussehen fuer `react-day-picker` — Einzeldatum wie Zeitraum.
 *
 * Zwei Kalender mit eigenen Klassenlisten driften sichtbar auseinander; beide greifen deshalb
 * auf diese Quelle zu. Bereichszustaende (`range_*`) landen in v9 auf der Tageszelle, nicht auf
 * dem Knopf — deshalb faerbt die Zelle den Streifen und der Knopf nur die Enden.
 */
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ClassNames } from 'react-day-picker';

export const dayPickerClassNames: Partial<ClassNames> = {
  root: 'text-ink relative',
  months: 'flex flex-col gap-6 sm:flex-row',
  month: 'flex flex-col gap-2',
  month_caption: 'flex items-center justify-center py-1',
  caption_label: 'font-serif text-[15px] text-ink tabular-nums',
  nav: 'absolute right-0 top-0.5 flex items-center gap-1',
  button_previous:
    'grid size-6 place-items-center rounded-md border border-line/50 text-ink-soft hover:bg-paper hover:text-ink transition-colors disabled:opacity-30',
  button_next:
    'grid size-6 place-items-center rounded-md border border-line/50 text-ink-soft hover:bg-paper hover:text-ink transition-colors disabled:opacity-30',
  month_grid: 'w-full border-collapse',
  weekdays: 'flex',
  weekday:
    'w-9 text-ink-faint text-[10px] font-semibold uppercase tracking-[0.14em] py-1 text-center',
  week: 'flex w-full',
  day: 'size-9 p-0 text-center text-[13px] tabular-nums',
  day_button:
    'size-full rounded-md text-ink hover:bg-paper/70 transition-colors data-[selected-single=true]:bg-sealwax data-[selected-single=true]:text-white data-[selected-single=true]:font-semibold data-[selected-single=true]:hover:bg-sealwax',
  today: 'font-semibold text-sealwax',
  outside: 'text-ink-faint/50',
  disabled: 'text-ink-faint/30 cursor-not-allowed [&>button]:hover:bg-transparent',
};

/** Bereichsauswahl: Streifen in der Auswahlfarbe, Enden in Salbei. */
export const dayPickerRangeClassNames: Partial<ClassNames> = {
  ...dayPickerClassNames,
  today: 'font-semibold text-sage',
  range_middle: 'bg-selection/45 [&>button]:rounded-none [&>button]:hover:bg-selection/70',
  range_start:
    'bg-selection/45 rounded-l-md [&>button]:bg-sage [&>button]:text-white [&>button]:font-semibold [&>button]:hover:bg-sage',
  range_end:
    'bg-selection/45 rounded-r-md [&>button]:bg-sage [&>button]:text-white [&>button]:font-semibold [&>button]:hover:bg-sage',
};

export function DayPickerChevron({ orientation }: { orientation?: string }) {
  return orientation === 'left' ? (
    <ChevronLeft size={14} strokeWidth={2} />
  ) : (
    <ChevronRight size={14} strokeWidth={2} />
  );
}
